import getUserType from '../../utils/proxy-util/getUserType';
import isSns from '../../utils/proxy-util/isSns';
/**
 * 사용자 정보 요청하여 얻은 응를결과를 TvingUser로 반환합니다.
 * @param userInfoBody
 */
var proxyUserInfo = function (userInfoBody) {
    var tvingToken = userInfoBody.tvingToken, userNo = userInfoBody.userNo, userId = userInfoBody.userId, emailAddress = userInfoBody.emailAddress, emailVendor = userInfoBody.emailVendor, lastPasswordUpdateDate = userInfoBody.lastPasswordUpdateDate;
    var userType = getUserType(userInfoBody.userType, userInfoBody.cjOneMemberYn === 'Y');
    if (userNo === null) {
        throw new Error('userNo is null');
    }
    return {
        userToken: tvingToken,
        userNo: userNo,
        userId: userId,
        authToken: '',
        accessToken: '',
        refreshToken: '',
        isSns: isSns(userType),
        emailAddress: emailAddress,
        emailVendor: emailVendor,
        isRealNameConfirmed: userInfoBody.realNameConfirmYn === 'Y',
        lastPasswordUpdateDate: lastPasswordUpdateDate,
        userType: userType,
    };
};
export default proxyUserInfo;
